import React from 'react'
import styled from '@emotion/styled'

import vw from 'styles/utils';
import media from 'styles/media';

function Advertisement() {
  return (
    <Root as="a" href="https://lihi2.com/MPQg0" target="_blank">
      {/* <p>廣告版位</p> */}
    </Root>
  )
}

const Root = styled.section`
  max-width: 100%;
  background-image: url(${require('assets/images/home/advertisment.png')});
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;

  ${vw('width', 300, 768, 805)}
  ${vw('height', 110, 240, 300)}
  ${vw('margin-bottom', 20, 30, 60)}

  @media ${media.tablet} {
    max-width: 90%;
  }

  @media ${media.desktop} {
    max-width: 70%;
  }

  > p {
    color: #FFFFFF;
  }
`;

export default Advertisement
